import { render, staticRenderFns } from "./document-plus.vue?vue&type=template&id=7a92430c&"
import script from "./document-plus.vue?vue&type=script&lang=js&"
export * from "./document-plus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a92430c')) {
      api.createRecord('7a92430c', component.options)
    } else {
      api.reload('7a92430c', component.options)
    }
    module.hot.accept("./document-plus.vue?vue&type=template&id=7a92430c&", function () {
      api.rerender('7a92430c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/document-plus.vue"
export default component.exports